import React from 'react';

import { SEO } from 'main/components';

export const EUBodyCamBluetooth: React.FC = () => {
  // const contactHref = 'mailto:dragan@orqafpv.com';

  return (
    <>
      <SEO seoTitle="BodyCam and Bluetooth - Orqa" noindex={true} />
      <section className="projects">
        <header className="projects__header">
          <p className="t-zeta t-upperext  t-nowrap o-40 s-bottom--sml">
            EU Projects
          </p>
          <h1 className="t-beta t-primary t-center s-bottom--sml">
            Razvojna ispitivanja na proizvodima Orqa BodyCam i Bluetooth modul
          </h1>
          <p className="t-zeta t-center o-40 s-bottom--med">
            (Kod projekta: PK.1.1.06.0054)
          </p>
        </header>
        <div className="projects__sponsors">
          <img
            src={require('main/assets/images/Amblem.webp')}
            alt="ESIF logo"
            className="projects__sponsors__img"
          />
        </div>
        <div className="wrapper wrapper--ultranarrow">
          <p className="s-bottom--med">
            <b>Poziv:</b> „Inovacijski vaučeri za MSP-ove”
          </p>

          <h5 className="s-bottom--med">Opis projekta:</h5>
          <p className="t-delta s-bottom--med">
            Prijavitelj se bavi razvojem vrlo kompleksne tehnologije širokog
            spektra primjene (industrija, javna sigurnost, bespilotni sustavi),
            a bazirana je na prijenosu video signala niske latencije.
          </p>
          <p className="t-delta s-bottom--med">
            Takvi sustavi se sastoje od velikog broja komponenata koje podliježu
            različitim regulatornim pravilima koja se razlikuju ovisno o državi.
          </p>
          <p className="t-delta s-bottom--med">
            Cilj ovog projekta je provesti ispitivanja i mjerenja za potrebe
            ishodovanja potrebnih certifikata kao jedan od preduvjeta za
            plasiranje na tržište dva nova proizvoda - Orqa BodyCam-a i
            Bluetooth modula.
          </p>
          <p className="s-bottom--med">
            Ukupna vrijednost projekta: 10.400,00 €
          </p>
          <p className="s-bottom--med">
            Iznos bespovratnih sredstava: 8.840,00 €
          </p>
          <p className="s-bottom--med">
            Početak razdoblja provedbe projekta: 21.02.2025.
          </p>
          <p className="s-bottom--med">
            Kraj razdoblja provedbe projekta: 21.06.2025.
          </p>
          <p className="t-zeta o-60">
            Sadržaj je isključiva odgovornost tvrtke Orqa d.o.o. i ni pod kojim
            uvjetima ne odražava stav Europske unije.
          </p>
        </div>
      </section>
    </>
  );
};
